
import axios from 'axios'
// import lodash from 'lodash'
const state = {
  currentPlayingcontent: null,
  currentContentPath: null,
  showLoader: false,
  isPlaylist: false,
  showNext: true,
  showPrevious: false,
  currentContentViewerPlaylist: [],
  previousHitTime: 0,
  isPurchase: false,
  previousContentData: {}
}
const getters = {
  getcurrentPlayingContent: state => state.currentPlayingcontent,
  getCurrentContentPath: (state, getters) => languageId => {
    for (var i = 0; i < getters.getcurrentPlayingContent.path.length; i++) {
      if (getters.getcurrentPlayingContent.path[i].languageId === languageId) {
        return getters.getcurrentPlayingContent.path[i].filePath
      }
    }
   // return state.currentPlayingcontent.path[0].filePath
  },
  getLoaderStatus: state => state.showLoader,
  getIsplaylist: state => state.isPlaylist,
  getShowNextStatus: state => state.showNext,
  getShowPreviousStatus: state => state.showPrevious,
  getCurrentContentViewerPlaylist: state => state.currentContentViewerPlaylist,
  getContentById: (state, getters) => contentId => {
    // console.log(contentId)
    if (getters.getCurrentContentViewerPlaylist !== null) {
      for (var i = 0; i < getters.getCurrentContentViewerPlaylist.length; i++) {
        if (getters.getCurrentContentViewerPlaylist[i].contentId === contentId) {
          return getters.getCurrentContentViewerPlaylist[i]
        }
      }
    }
  },
  getPreviousHitTime: state => state.previousHitTime,
  getIsPurchase: (state, getters) => itemId => {
    var result = false
    if (getters.getProfileDetails !== null) {
      for (var i = 0; i < getters.getItemsEnrolledByType('LO').length; i++) {
        if (getters.getItemsEnrolledByType('LO')[i].contentId === itemId) {
          result = true
        }
      }
      return result
    }
  },
  /* getIsPurchase: (state, getters) => itemId => {
    var result = false
    if (getters.getProfileDetails !== null) {
      for (var i = 0; i < getters.getLOsEnrolled.length; i++) {
        if (getters.getLOsEnrolled[i].contentId === itemId) {
          result = true
        }
      }
      return result
    }
  }, */
  getPreviousContent: state => state.previousContentData,
  getSearchPlaylistLO: (state, getters) => inputString => {
    var result = []
    if (inputString !== '') {
      result = getters.getCurrentContentViewerPlaylist.filter(obj => {
        return obj.title.toLowerCase().includes(inputString.toLowerCase())
      })
    } else {
      result = getters.getCurrentContentViewerPlaylist
    }
    return result
  }
}
const mutations = {
  setCurrentPlayingContent (state, data) {
    state.currentPlayingcontent = data
  },
  setLoaderStatus (state, data) {
    state.showLoader = data
  },
  setIsPlaylist (state, data) {
    state.isPlaylist = data
  },
  setShowNext (state, data) {
    state.showNext = data
  },
  setShowPrevious (state, data) {
    state.showPrevious = data
  },
  setCurrentContentViewerPlaylist (state, data) {
    state.currentContentViewerPlaylist = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].type === 'LO') {
        state.currentContentViewerPlaylist.push(data[i])
      }
    }
  },
  setPreviousHitTime (state, data) {
    state.previousHitTime = data
  },
  setPreviousContent (state, data) {
    state.previousContentData = data
  },
  setCurrentLanguage (state, data) {
    // console.log('mutations call')
    state.currentLanguageId = data
  }
}

const actions = {
  // get item purchase status
  // 3 response : ITEM_NOT_PURCHASED_BY_USER, VIEW_LIMIT_CROSSED, ITEM_NOT_EXPIRED
  getPurchaseStatus (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('r/viewItemValidityStatus', data).then(response => {
        /* if (response.data === 'ITEM_NOT_PURCHASED_BY_USER') {
          this.isPurchase = false
        }
        if (response.data === 'VIEW_LIMIT_CROSSED') {
          this.isPurchase = false
          this.showViewCountExhaustedMsg = true
        }
        if (response.data === 'ITEM_NOT_EXPIRED') {
          this.isPurchase = true
        } */
        resolve(response)
      }).catch(err => {
        console.log('error in getting purchase status : ', err)
        reject(err)
      })
    })
  },
  // updates the watch count of LO
  updatelowatchcount (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('r/contentviewer/updatelowatchcount', data).then(response => {
        resolve()
      }).catch(err => {
        console.log('error in updatelowatchcount : ', err)
        reject()
      })
    })
  },
  // shows rating
  showRating (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/rating/addratingdata', data)
        .then(response => {
          resolve()
        })
        .catch(error => {
          // this.$toasted.error(error)
          console.log('error in showing rating : ', error)
          reject(error)
        })
    })
  },
  setCurrentPlayingContent (context, data) {
    return new Promise((resolve, reject) => {
      context.commit('setCurrentPlayingContent', data)
      resolve()
    })
    .catch(error => {
      // this.$toasted.error(error)
      console.log('error in showing rating12345678 : ', error)
      // reject(error)
    })
    // context.commit('setCurrentPlayingContent', data)
  },
  setLoaderStatus (context, data) {
    return new Promise((resolve) => {
      context.commit('setLoaderStatus', data)
      resolve()
    })
  },
  setIsPlaylist (context, data) {
    return new Promise((resolve) => {
      context.commit('setIsPlaylist', data)
      resolve()
    })
  },
  updatePlaylistItemDuration (context, data) {
    return new Promise((resolve) => {
      context.commit('updatePlaylistItemDuration', data)
      resolve()
    })
  },
  setShowNext (context, data) {
    return new Promise((resolve) => {
      context.commit('setShowNext', data)
      resolve()
    })
  },
  setShowPrevious (context, data) {
    return new Promise((resolve) => {
      context.commit('setShowPrevious', data)
      resolve()
    })
  },
  setCurrentContentViewerPlaylist (context, data) {
    return new Promise((resolve) => {
      context.commit('setCurrentContentViewerPlaylist', data)
      resolve()
    })
  },
  setPreviousHitTime (context, data) {
    return new Promise((resolve) => {
      context.commit('setPreviousHitTime', data)
      resolve()
    })
  },
  setPreviousContent (context, data) {
    return new Promise((resolve) => {
      context.commit('setPreviousContent', data)
      resolve()
    })
  },
  setCurrentLang (context, data) {
    return new Promise((resolve) => {
      // console.log('action call')
      context.commit('setCurrentLanguage', data)
      resolve()
    })
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contentViewer.js